module.exports = __webpack_public_path__ + "static/media/Logo.0731fdc4.png";